// Public page copy: rendered without the admin i18n context, keyed by the recipient's language.
export type UnsubscribeLang = "fr" | "en";

export const UNSUBSCRIBE_COPY = {
  fr: {
    title: "Désabonnement",
    loading: "Chargement…",
    intro:
      "Confirmez que vous ne voulez plus recevoir de courriels de Gavion à l'adresse",
    button: "Me désabonner",
    working: "Traitement en cours…",
    done: "Votre désabonnement est confirmé.",
    doneDetail: "Vous ne recevrez plus nos courriels marketing.",
    invalid: "Ce lien de désabonnement n'est pas valide.",
    rateLimited: "Trop de tentatives. Réessayez dans quelques minutes.",
    error: "Une erreur est survenue. Réessayez ou écrivez à sales@gavion.ai.",
    retry: "Réessayer",
    introNoAddress:
      "Confirmez que vous ne voulez plus recevoir de courriels de Gavion.",
    questions: "Questions :",
    privacy: "Responsable de la protection des renseignements personnels :",
  },
  en: {
    title: "Unsubscribe",
    loading: "Loading…",
    intro: "Confirm that you no longer want to receive emails from Gavion at",
    button: "Unsubscribe me",
    working: "Processing…",
    done: "Your unsubscribe is confirmed.",
    doneDetail: "You will no longer receive our marketing emails.",
    invalid: "This unsubscribe link is not valid.",
    rateLimited: "Too many attempts. Please try again in a few minutes.",
    error: "Something went wrong. Try again or write to sales@gavion.ai.",
    retry: "Retry",
    introNoAddress:
      "Confirm that you no longer want to receive emails from Gavion.",
    questions: "Questions:",
    privacy: "Privacy officer:",
  },
} as const;
